{
    "Profile_Dwellings_Garage.garage": "FR: Garage",
    "Profile_Dwellings_Garage.garageDetails": "FR: Garage Details",
    "Profile_Dwellings_Garage.type": "FR: Type",
    "Profile_Dwellings_Garage.numberOfCars": "FR: Number of Cars"
}
